// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1Kz2Z","info":"Note_info__3vSCX","note":"Note_note__2kUIP","actions":"Note_actions__24uM9"};